/**
 * Права доступу — мінімальний реальний набір: перегляд + модерація (бан/заморозка/
 * верифікація/скарги/верифікатор бота) + суперадмін (керує обліковими записами
 * адмінів). Сервер (`MyTelegram.AdminServer`, `[Authorize]` + `AdminAccount.Role`) —
 * джерело істини; клієнт лише вирішує, що ПОКАЗУВАТИ.
 */

import type { AdminIdentity } from './auth'

export const PERMISSIONS = {
  USERS_VIEW: 'users.list.view',
  USERS_MODERATE: 'users.moderate',
} as const

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS] | (string & {})

const ALL = '*' as const

export function permissionsOf(identity: AdminIdentity | null): readonly string[] {
  if (!identity) return []
  if (identity.permissions?.length) return identity.permissions
  return identity.role === 'superadmin' ? [ALL] : Object.values(PERMISSIONS)
}

export function can(identity: AdminIdentity | null, permission: Permission): boolean {
  if (!identity) return false
  const perms = permissionsOf(identity)
  return perms.includes(ALL) || perms.includes(permission)
}
